export default __webpack_public_path__ + "static/media/gallery-01_full.2cd75e64.jpg";